<script setup lang="ts">
import { type PropType, ref } from 'vue';
import Button from 'primevue/button';
import ToggleSwitch from 'primevue/toggleswitch';
import { type FormField, FormFieldType } from '@/models';
import { ButtonType, CustomButton } from '@/components';

const props = defineProps({
  field: {
    type: Object as PropType<FormField>,
    required: true
  }
});

const localField = ref<FormField>(props.field);

const emits = defineEmits(['onAddField', 'onDeleteField', 'onCloneField', 'onReorderFields']);

const onAddField = () => {
  emits('onAddField');
};

const onDeleteField = () => {
  emits('onDeleteField');
};

const onCloneField = () => {
  emits('onCloneField');
};

const onReorderFields = () => {
  emits('onReorderFields');
};
</script>

<template>
    <section class="field-bottom-buttons">
        <div class="buttons-right">
          <div class="allow-other-toggle"
            v-if="(localField.type === FormFieldType.CHOICE || localField.type === FormFieldType.DROPDOWN) && localField.expanded === true">
            <div class="allow-other-title">
              Allow other
            </div>
            <ToggleSwitch v-model="localField.options.allowOther"/>
          </div>
          <Button icon="pi pi-arrows-alt"
            outlined
            class="button"
            @click="onReorderFields"
            v-ripple />
          <Button icon="pi pi-trash"
            outlined
            class="button red"
            @click="onDeleteField"
            v-ripple />
          <Button icon="pi pi-clone"
            outlined
            class="button"
            @click="onCloneField"
            v-ripple />
          <CustomButton text="Add field"
            :icon="{ style: 'fas', icon: 'plus' }"
            :margin-left="16"
            @onClick="onAddField"
            :type="ButtonType.OUTLINED"/>
        </div>
      </section>
</template>

<style scoped lang="scss">
@use "../../../assets/main.scss" as *;
.button {
  margin-left: 16px;
}
.arrow-button {
  border: none;
}
:deep(.p-button-outlined) {
  border: 1px solid $disabled;
  border-radius: 4px;
  color: black;

  &:not(:disabled):hover {
    border: 1px solid $disabled;
    background-color: $disabled;
    color: black;
  }
}
.red {
  color: hsl(354, 81%, 56%);
  border: 1px solid hsl(354, 81%, 56%);

  &:not(:disabled):hover {
    background-color: hsl(354, 81%, 56%, 0.75);
    color: hsl(354, 81%, 56%);
  }
}
.buttons-right {
  display: flex;

  .allow-other-toggle {
    display: flex;
    align-items: center;
    margin-right: 24px;

    .allow-other-title {
      margin-right: 8px;
    }
  }
}
</style>
